export default __webpack_public_path__ + "static/media/logoPosR.5e5a12d7.png";